import React, { useState, useEffect, useRef } from 'react';
import { css } from '@emotion/react';

export default function Clamp(props) {
  const [enableClamp, setEnableClamp] = useState(true);
  const [clamped, setClamped] = useState(true);
  const ref = useRef(null);

  useEffect(() => {
    if (!props.forceClamp) {
      setEnableClamp(ref.current.scrollHeight > ref.current.clientHeight);
    }
  }, []);

  return (
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */
    <div
      ref={ref}
      css={css`
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${(enableClamp && clamped) ? props.lines : 0};
        overflow: hidden;
        cursor: pointer;
        cursor: ${(enableClamp) ? 'pointer' : 'auto'};
      `}
      role={(enableClamp) ? 'button' : 'complementary'}
      aria-expanded={(!enableClamp || !clamped) ? true : false}
      /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
      tabIndex={(enableClamp) ? 0 : undefined}
      className={props.className}
      onMouseDown={(e) => {
        e.persist();

        if (e.target.tagName !== 'A')
          setClamped(!clamped);
      }}
      onKeyPress={(e) => {
        e.persist();

        if (e.key === 'Enter')
          setClamped(!clamped);
      }}
    >
      {props.children}
    </div>
  )
}
